import React from "react";
import NoneJoined from "../../NoneJoined/NoneJoined";
import DebatorView from "../../DebatorView/DebatorView";

const DebateScreen = ({ team, activeSpeakers, teamOne }) => {
  return (
    <div className="box_wrappers">
      <div className="screen_box_header">
        <div className="screen_box_team_name_box">
          <img
            width="94"
            height="94"
            src="https://img.icons8.com/3d-fluency/94/user-group-man-woman--v2.png"
            alt="user-group-man-woman--v2"
          />{" "}
          <h4 className="team_name_debate_screen teamOne">{team?.name}</h4>
        </div>
      </div>
      <div className="left_team">
        {team && team.members?.length > 0 ? (
          team?.members?.map((mem) => (
            <DebatorView
              activeSpeakers={activeSpeakers}
              debator={mem}
              key={mem.id}
            />
          ))
        ) : (
          <NoneJoined
            team={team?.name}
            roboImg={teamOne ? "/images/roboTeam.png" : "/images/roboTeam2.png"}
          />
        )}
      </div>
    </div>
  );
};

export default DebateScreen;
